import PropTypes from 'prop-types';

const book = PropTypes.shape({
  indexable: PropTypes.bool,
  image_name: PropTypes.string,
  isbn: PropTypes.string,
  licensed: PropTypes.bool,
  ranking_recommendations: PropTypes.number,
  recommendations_count: PropTypes.number,
  signature_: PropTypes.string,
  title: PropTypes.string,
});

export default {
  book,
  books: PropTypes.arrayOf(book),
};
